import * as React from "react";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { As400TitleDto, DogTitlesApi } from "../../../../../../api";
import { SmallFormGenerator } from "../../../../../../components";
import { FGTextInput } from "nsitools-react";
import { ETLCodes } from "../../../../../../locales";

export interface IDogAs400FormProps {
  dogId: number;
  editMode: boolean;
}

export const DogAs400Form: React.FunctionComponent<IDogAs400FormProps> = ({ dogId, editMode }) => {
  const api = useApiService(DogTitlesApi);
  const { t } = useTl();
  const { data, loading, saving, saveItem } = useCrudApi<As400TitleDto>(
    React.useMemo(
      () => ({
        getApiFn: async (id = dogId) =>
          id > 0 ? api.getdogTitleAs400(id) : As400TitleDto.fromJS({ dogId: id }).toJSON(),
        saveApiFn: (d: As400TitleDto) => api.updateDogTitleAs400(d.dogId, d.as400Titles),
      }),
      [api, dogId]
    )
  );

  return (
    <SmallFormGenerator initialValues={data} onSubmit={saveItem} editMode={editMode} loading={loading} saving={saving}>
      <FGTextInput name="as400Titles" label={t(ETLCodes.AS400Title)} />
    </SmallFormGenerator>
  );
};
